export * from './collectible.service';
export * from './collectible.model';
